import {
  WSElement,
  WSElementProps,
  WSTable,
  WSTableCell
} from "@wingspanhq/fe-component-library";
import { IPayableSchema } from "@wingspanhq/payments/dist/interfaces";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { calculateLineItemsTotal } from "../../utils";

type Props = { payables: IPayableSchema[] } & WSElementProps;

export const PayablesMiniTable: React.FC<Props> = ({
  payables,
  ...elementProps
}) => (
  <WSElement {...elementProps}>
    <WSTable
      tableData={payables.map(payable => ({
        id: payable.payableId,
        data: payable
      }))}
      columns={[
        {
          renderFunction: row => (
            <WSTableCell text={`#${row.data.invoiceNumber}`} />
          )
        },
        {
          config: {
            justify: "end"
          },
          renderFunction: row => (
            <WSTableCell
              text={formatMoney(
                calculateLineItemsTotal(row.data.lineItems),
                row.data.currency
              )}
            />
          )
        }
      ]}
    />
  </WSElement>
);
